import React from "react";
import ImageHelper from "../Helpers/ImageHelper";

const Banner = () => {
  return (
    <>
      <section className="banner-area homepage-banner-area">
        <div className="container">
          <div className="row fullscreen align-items-center justify-content-between d-md-inline-flex">
            <div className="col-lg-6 col-md-6 banner-left">
              <h1 className="text-uppercase" style={{ margin: "20px 0" }}>
                Not hiring right now
              </h1>
              <h2 id="sub-text">But we're always glad to hear from strong people</h2>
              <p>
                TZ Creation is a remote-first team. Reach out and we'll keep
                you in mind when a role opens up.
              </p>
              <a
                href="/contact-us"
                id="first-btn"
                className="primary-btn text-uppercase"
              >
                Get in Touch
              </a>
            </div>
            <div className="col-lg-6 col-md-6 banner-right align-self-end">
              <img className="img-fluid" src={ImageHelper.HeroImage} alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
